import Admin from "../pages/Admin/Admin";
import Admission from "../pages/Admin/Admission";
import Alumni from "../pages/Admin/Alumni";
import Contact from "../pages/Admin/Contact";
import Dashboard from "../pages/Admin/Dashboard";
import Download from "../pages/Admin/Download";
import EditDownload from "../pages/Admin/EditDownload";
import EditGallery from "../pages/Admin/EditGallery";
import EditNotice from "../pages/Admin/EditNotice";
import Gallery from "../pages/Admin/Gallery";
import Notice from "../pages/Admin/Notice";
import OurTeam from "../pages/Admin/OurTeam";
import ShowImages from "../pages/Admin/ShowImages";
import DownloadAdmission from "../pages/Admin/DownloadAdmission";
import NewsAdmin from "../pages/Admin/NewsAdmin";
export const adminRoutes = [
  {
    label: "Admin",
    path: "/nvm-admin",
    element: <Admin />,
  },
  {
    label: "News & Events",
    path: "/nvm-admin/news",
    element: <NewsAdmin />,
  },
  {
    label: "Admission",
    path: "/nvm-admin/admission",
    element: <Admission />,
  },
  {
    label: "Contact",
    path: "/nvm-admin/contact",
    element: <Contact />,
  },
  {
    label: "Dashboard",
    path: "/nvm-admin/dashboard",
    element: <Dashboard />,
  },

  {
    label: "Alumni",
    path: "/nvm-admin/alumni",
    element: <Alumni />,
  },

  {
    label: "Gallery",
    path: "/nvm-admin/gallery",
    element: <Gallery />,
  },
  {
    label: "Notice",
    path: "/nvm-admin/notice",
    element: <Notice />,
  },
  {
    label: "Download",
    path: "/nvm-admin/download",
    element: <Download />,
  },
  {
    label: "OurTeam",
    path: "/nvm-admin/our-teams",
    element: <OurTeam />,
  },
  {
    label: "Edit Gallery",
    path: "/nvm-admin/gallery/edit/:title",
    element: <EditGallery />,
  },
  {
    label: "Show Images",
    path: "/nvm-admin/gallery/:title",
    element: <ShowImages />,
  },
  {
    label: "Show Notice",
    path: "/nvm-admin/notice/edit/:title",
    element: <EditNotice />,
  },
  {
    label: "Edit Download",
    path: "/nvm-admin/download/edit/:title",
    element: <EditDownload />,
  },
  {
    label: "Admission Details Download",
    path: "/nvm-admin/admission/download",
    element: <DownloadAdmission />,
  },
];
